<template>
	
    <div class="row">
        
        <div class="col-md-12">
            <div>
                All sign ups assigned <input style="width: fit-content;display: inline;" maxlenght="6" size="6"
                                              id="referral_points" name="signup_points" class="form-control"
                                              type="text" v-model.number="signup_points"/> points
                <span class="invalid-feedback" style="display: block;"
                      v-if="errors.signup_points">@{{ errors.signup_points }}</span>
            </div>
         
			<div>
				Referral <input style="width: fit-content;display: inline;" maxlenght="6" size="6"
											 id="referral_points" name="referral_points" class="form-control"
											 type="text" v-model.number="referral_points"/> points
				<span class="invalid-feedback" style="display: block;"
					  v-if="errors.referral_points">@{{ errors.referral_points }}</span>
			</div>
		</div>
	</div>
</template>

<script>


export default {
    props: {
        deal: Object,
        rule: Object,
    },
    data: () => ({
        errors: {},
    }),
    methods: {
        isNumber(evt) {
            const keyPressed = evt.key;
            if (keyPressed < '0' || keyPressed > '9') {
                evt.preventDefault()
            }
        },
    },
    computed: {
		referral_points: {
            get() {
                return this.rule.settings.referral_points;
            },
            set(newVal) {
                this.$set(this.rule.settings, 'referral_points', newVal);
            },
        },
		signup_points: {
			get() {
				return this.rule.settings.signup_points;
			},
			set(newVal) {
				this.$set(this.rule.settings, 'signup_points', newVal);
			},
		},
	},
	watch: {
		referral_points: function (val) {
			if (val < 0) {
				this.$set(this.errors, 'referral_points', 'Points must be greater than or equal to 0');
			} else {
				this.$set(this.errors, 'referral_points', '');
			}
		}
         
    }
}
</script>